const hasUsableData = (data) => Array.isArray(data) && data.length > 0;

export const shouldShowMatchedAssetsInitialLoading = ({
  isRequestReady,
  params,
  queryLoading,
  data,
}) => !hasUsableData(data) && Boolean(queryLoading || !isRequestReady || !params);

export const shouldShowScannerSectionsSkeleton = (isLoading, data) =>
  Boolean(isLoading) && !hasUsableData(data);

export const shouldShowScannerInitialSkeleton = ({
  activePlanLoading,
  doesUserHavePermission,
  isActive,
}) =>
  Boolean(activePlanLoading) ||
  doesUserHavePermission === null ||
  isActive === null;
